import { signOut } from 'aws-amplify/auth';
import { getAuthenticatedUser } from '../AuthHandler';

export type GQLResponse<T> = Promise<{
  data: T;
  errors?: [{ message: string }];
}>;

export const queryAPI = <T>(
  query: string,
  variables?: { [key: string]: unknown }
): GQLResponse<T> => {
  return getAuthenticatedUser().then((user) => {
    const token = user.session?.accessToken.toString();
    if (!token) {
      signOut();
      console.log('failed to retrieve access token for user');
      throw new Error(`Access token not found for user`);
    }
    return fetch(process.env.REACT_APP_API_URL || '', {
      method: 'POST',
      headers: {
        Authorization: token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query,
        variables,
      }),
    })
      .then(
        (res) => {
          if (res.status === 401 || res.status === 403) {
            signOut();
          }
          return res.json();
        },
        (err) => {
          console.log('failed on appsync' + err.toString());
        }
      )
      .catch((err) => {
        console.log('CATCH ');
        console.log(err);
      });
  });
};
